export const Notification = {
    fromServer: (data) => {
        return {
            unread: data.unread,
            type: data.type,
            resource: data.content_type,
            id: data.content_id,
            text: data.content_context,
            created_at: data.created_at,
            extra: data.extra || {}
        }
    }
}